function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M58.769 16.917a2.546 2.546 0 00-4.397-2.567 2.544 2.544 0 00.446 3.128c-3.468 4.205-9.796 11.874-11.325 13.733-.448-.2-.913-.39-1.396-.569.136-1.425 1.139-12.312 1.671-18.101a2.547 2.547 0 002.523-1.906 2.547 2.547 0 00-4.93-1.276 2.548 2.548 0 001.28 2.89 9880.867 9880.867 0 00-7.385 16.783c-.003.011-.001.023-.004.034-.442-.054-.896-.1-1.358-.138-.093-.612-2.18-13.417-3.268-20.086a2.827 2.827 0 00-.647-5.58 2.827 2.827 0 00-.645 5.58c-1.083 6.638-3.157 19.357-3.266 20.075-.484.039-.956.086-1.419.14-.003-.017-.002-.03-.007-.045-.012-.046-4.879-11.094-7.385-16.784a2.547 2.547 0 001.28-2.89 2.547 2.547 0 00-4.929 1.276 2.545 2.545 0 002.522 1.905c.532 5.784 1.53 16.648 1.671 18.097-.475.172-.93.357-1.372.551-1.59-1.931-7.847-9.516-11.29-13.688a2.546 2.546 0 10-1.004.587c2.07 5.393 8.754 22.748 9.01 22.987h.002c.005.03.662 4.335.734 5.763.072 1.42-.546 4.894-.5 4.914v.004l.001-.002c4.957 2.321 10.601 3.626 16.654 3.626 6.11 0 17.139-3.736 17.087-3.76-.72-1.522-.449-10.546-.449-10.546.256-.242 7.026-17.452 9.151-22.986a2.531 2.531 0 002.93-1.148",
  stroke: "#000",
  strokeWidth: 0.7101327199999999,
  strokeLinejoin: "bevel"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "#fff",
  strokeWidth: 2.912,
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.61 50.696c5.211-2.147 10.09-3.07 16.067-3.07 5.74 0 10.336.951 15.14 2.942M44.826 40.633c-4.24-1.63-9.433-2.588-15.043-2.588-5.661 0-10.896.976-15.156 2.63",
  strokeWidth: 0.77045696
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M45.334 47.725c-4.692-1.55-9.469-2.676-14.847-2.676-5.48 0-10.76 1.158-15.712 2.764",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 0.77045696,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M30.001 40.75l-2.364 1.181L30 43.113l2.372-1.182zM39.898 41.923l2.148 1.548-2.522.79-2.148-1.547zM20.112 41.923l-2.148 1.548 2.523.79 2.147-1.547z"
});

function SvgBlackQueen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgBlackQueen;